import { NgModule } from '@angular/core';
import { ManageProjectsRoutingModule } from './manage-projects-routing.module';


@NgModule({
  declarations: [],
  imports: [
    ManageProjectsRoutingModule,
  ]
})
export class ManageProjectsModule { }
